import { useState } from 'react';

const BlogSearch = ({ onSearch }) => {
  const [q, setQ] = useState('');

  const handleSearch = () => {
    onSearch(q);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <div className="flex gap-3">
      <input
        className="flex-1 border border-gray-300 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
        placeholder="Search articles by title or keyword..."
        value={q}
        onChange={(e) => setQ(e.target.value)}
        onKeyPress={handleKeyPress}
      />
      <button
        onClick={handleSearch}
        className="bg-blue-600 text-white font-semibold px-6 py-3 rounded-lg hover:bg-blue-700 transition"
      >
        Search
      </button>
    </div>
  );
};

export default BlogSearch;
